import React from "react"
import reviewsData from "../refdata/reviews.json"
import ReviewCard from "../components/mmp-review-card"
import PageMeta from "../components/page-meta"

export default function AboutPage() {
    return <>

        <PageMeta
            title="About Us"
            description="Meet Sue Tarbard, creator of My Mini Prints. Passionate about creating beautiful, unique hand and foot casting keepsakes for babies and children in Essex."
            canonical="/about"
        />

        <div className="container">

            <br />
                <div className="card shadow">
                    <h1 className="card-header h1 display-4" style={{"backgroundColor": "#DCE774", "color": "#504E51"}}>About Us</h1>
                </div>
            <br />

            <div className="card mx-auto p-1 shadow" style={{"width" : "100%"}}>
                <div className="card-body">
                    <p className="card-text">
                    Hi, I am Sue Tarbard and am passionate about what I create. I have had a creative streak for as long as I can remember and it is wonderful to be able to use this within my work. 
                    <br />
                    <br />
                    As a child I had a love of drawing and colouring alongside painting numerous plaster of paris models that I had made in the kitchen. Later, as an outlet for my creative side, whilst working in London for a large Investment Company I enrolled in weekly calligraphy classes. After leaving the corporate world in 2004 to be with my young children I found that I had the opportunity to embark on a new career producing various unique keepsakes for little ones. 
                    <br />
                    <br />
                    At My Mini Prints I feel privileged to produce a range of keepsakes, that will be treasured by parents and children of today, and passed down through the generations of tomorrow. 
                    </p>
                </div>
                
            </div>
        <br />

        <h2 className="mx-auto p-1">Reviews</h2>

        {reviewsData.Reviews.map((review) => (
            <React.Fragment key={review.ReviewerName}>
                <ReviewCard review={review.ReviewText} reviewer={review.ReviewerName}></ReviewCard>
                <br />
            </React.Fragment>
        ))}
        </div>

        <br />
        <br />

    </>

}